export const DefaultUploadFileTypeAccept = 'image/*, video/*, .pdf';
export const DefaultAllowedMimeTypeUpload = ['application/pdf', 'image/*', 'video/*'];
